import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Crown, ArrowUpRight } from "lucide-react";

export default function PremiumHint({ text }) {
  const { user } = useAuth();
  if (user?.is_premium) return null;
  return (
    <Link to="/premium" data-testid="premium-hint"
      className="mt-8 flex items-center justify-between gap-4 rounded-2xl border border-gold/25 bg-gradient-to-r from-[#BF953F]/10 to-transparent p-4 hover:border-gold/50 transition-colors group">
      <div className="flex items-center gap-3">
        <Crown className="text-gold shrink-0" size={20} />
        <p className="text-sm text-white/70">
          {text || "Passez à Premium pour une IA plus généreuse, le Coach d'argumentation et bien plus."}
        </p>
      </div>
      <ArrowUpRight size={18} className="text-gold shrink-0 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
    </Link>
  );
}
